<div class="dataMismatchPopup pos-relative">
  <button
    [attr.id]="buildControlId('btn-close')"
    (click)="onCloseClick()"
    class="closeBtn pull-right"
    mat-button
    color="accent"
    >
    <span class="icon-ic-close popup_close"></span>
  </button>
  <h5 class="p-20 m-0 bottomBorderStyle align font-xl p-t-m-i">
    One or more package(s) cannot be transferred
  </h5>

  <div class="form-label m-b-s align">
    The following package(s) cannot be transferred because of mismatch in package folder tags
  </div>

  <div class="dataMismatchTableContainer">
    <table [attr.id]="buildControlId('tbl-tag-mismatch')" class="w-100" mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="Package folder">
        <th mat-header-cell *matHeaderCellDef class="align-items">
          Package folder
        </th>
        <td mat-cell *matCellDef="let item">{{ item.PackageFolderName }}</td>
      </ng-container>

      <ng-container matColumnDef="{{ this.sourceBucket }}">
        <th mat-header-cell *matHeaderCellDef>{{ this.sourceBucket }}</th>
        <td mat-cell *matCellDef="let item">
          @for (tag of item.MismatchedTags; track tag) {
            <div>{{ tag.SourceBucketTagValue }}</div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="{{ this.destinationBucket }}">
        <th mat-header-cell *matHeaderCellDef>{{ this.destinationBucket }}</th>
        <td mat-cell *matCellDef="let item">
          @for (tag of item.MismatchedTags; track tag) {
            <div>{{ tag.TargetBucketTagValue }}</div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="header-row-first-group">
        <th
          class="mat-header-cell align-items"
          mat-header-cell
          *matHeaderCellDef
        ></th>
      </ng-container>

      <ng-container class="align" matColumnDef="header-row-second-group">
        <th
          class="mat-header-cell align-items"
          mat-header-cell
          *matHeaderCellDef
          [attr.colspan]="2"
          >
          Package folder tags
        </th>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="['header-row-first-group', 'header-row-second-group']"
      ></tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <div class="okayButtonContainer">
    <button
      [attr.id]="buildControlId('btn-ok')"
      mat-raised-button
      color="primary"
      type="submit"
      class="p-20 m-20 okbutton"
      (click)="onCloseClick()"
      >
      OK
    </button>
  </div>
</div>
